var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slide-transition',[_c('div',{staticClass:"nuttrema-layout-east-block",class:[ _vm.theme ? ("" + _vm.theme) : '' ]},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21dcc749","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/layout/nuttrema-layout-east-block.vue
// module id = 2965
// module chunks = 0